import SlideoutWrapper from "../../../components/slideoutWrapper/slideoutWrapper";
import { ReactComponent as MapIcon } from '../../../icons/map.svg';
import { SlideoutBtnPosition } from "../../../components/slideoutWrapper/types/slideoutWrapperProps";
import { KrFormViewProps } from "./types/krFormView";
import WebMap from "../../../components/webmap/webmap";
import './krFormView.scss';
import { useCallback, useContext, useEffect, useRef, useState } from "react";
import { apiContext } from "../../../contexts/apiContext";
import Spinner from "../../../components/spinner/spinner";
import Query from "@arcgis/core/rest/support/Query";
import { queryFeatureSet } from "../../../services/arcGisService/arcGisService";
import { populateRegistrationCardForm } from "../../../services/registrationCardService/registrationCardService";
import KrFormContext, { ConfigField, defaultKrForm, FormComment, KrEndangeredAreaFormTypes, krFormTypes, KrLandslideFormTypes } from "../../../contexts/krFormContext";
import { Dictionary, getAdditionalDictionaries, getDictionariesFromLayers, getDictionaryForCodedValues } from "../../../helpers/dictionariesFromLayers";
import { ClassNameSpinner } from "../../../components/spinner/types/spinnerProps";
import { prepareAllFields } from "../../../helpers/form";
import { createValidationKrForm } from "../../../helpers/validation/validation";
import { TitleBarProps } from "../shared/titleBar/types/titleBarProps";
import TitleBar from "../shared/titleBar/titleBar";
import KrFormLandslide from "./krFormObjectType/krFormLandslide";
import KrFormEndangeredArea from "./krFormObjectType/krFormEndangeredArea";
import { getRegistrationCardStatuses } from "../shared/titleBar/objectStatusList";
import PermissionsContext from "../../../contexts/permissionsContext";
import { ObjectType, PatternType } from "../../../contexts/types/card";
import { canAssignEditorInForm, canAssignVerifierInForm } from "../../../helpers/processHelper";
import AuthContext from "../../../contexts/authContext";
import { notifyError, notifySuccess, notifyWarn } from "../../../components/snackbar/snackbar";
import ViewContext from "../../../contexts/viewContext";
import { getCodedValuesDictionaries, getDictionaries, getTask, setCodedValuesDictionaries, setDicts, setTask } from "../../../database/indexedDbReadWrite";
import CommentsSidebar from "../shared/commentsSidebar/commentsSidebar";
import { CreateNewCommentDetails } from "../shared/commentsSidebar/types/commentsSidebarProps";
import { FormContextProps } from "./components/shared/types/formContextProps";
import { getHeadingByFieldDict } from "../shared/commentsSidebar/fieldDict";
import { mapStore } from "../../../stores/mapStore";
import { goToAll, showFeatures } from "../../../helpers/map/map";
import { ObjectState } from "../taskListView/types/tasklListViewProps";

const KrFormView = (props: KrFormViewProps) => {
    const api = useContext(apiContext);
    const { userRoles } = useContext(AuthContext);
    const { setViewType, viewTypes, krFormSavePrompt, setLocalView, setSavingLocal, savingLocal, setViewData } = useContext(ViewContext);
    const { functionsPermissions, extendedUserPermissions } = useContext(PermissionsContext);
    const [loading, setLoading] = useState<boolean>(true);
    const [loadingMap, setLoadingMap] = useState<boolean>(true);
    const [saving, setSaving] = useState<boolean>(false);
    const [krForm, setkrForm] = useState<krFormTypes>(defaultKrForm());
    const [showNewCommentField, setNewCommentField] = useState<CreateNewCommentDetails>({ visible: false, fieldFormName: undefined });
    const [showCommentSidebar, setShowCommentSidebar] = useState<boolean>(false);
    const [commentsExist, setCommentsExist] = useState<boolean>(false);
    const [commentsFilter, setCommentsFilter] = useState<string>();
    const [local] = useState<boolean>(props.data.local);

    const objectType = props.data.row.attributes.RODZAJ_OBIEKTU;

    let fillDateProp: number = objectType === ObjectType.KRO ?
    (krForm as KrLandslideFormTypes)?.landslideAttributes?.datA_WYPELNIENIA :
    (krForm as KrEndangeredAreaFormTypes)?.endangeredAreaAttributes?.datA_WYPELNIENIA;

    const [fillDate, setFillDate] = useState<number>(fillDateProp);
    const is2007 = props.data.row.attributes.WZOR === '2007';
    const configKey = objectType === ObjectType.KRO ? 'landslide' : 'endangeredArea';

    const preventReload = useRef(false);
    const showOnMap = useRef(false);

    useEffect(() => {
        if (krForm.waitingRoomGlobalId) {
            if (local && !savingLocal) {
                setSavingLocal(true);
                setTask(krForm,undefined, undefined, true, true).then((response) => {
                    setSavingLocal(false);
                }).catch((e) => {
                    console.log("Error saving local", e);
                    setSavingLocal(false);
                });
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [krForm, local, setSavingLocal])

    useEffect(() => {
        if (krFormSavePrompt) {
            setLoading(true);
        }
    }, [krFormSavePrompt])

    useEffect(() => {
        if (!local) {
            const unloadCallback = (event: any) => {
                event.preventDefault();
                event.returnValue = "";
                return "";
            };

            window.addEventListener("beforeunload", unloadCallback);
            return () => window.removeEventListener("beforeunload", unloadCallback);
        }
    }, [local]);

    const prepareFormLocal = (form: krFormTypes, element?: any, waitingRoomRecId?: number, dicts?: Dictionary, codedValues?: Dictionary, rodzajObiektu?: any) => {

        if (form.formComments) form.formComments = prepareComments(form.formComments);
        form.waitingRoomId = waitingRoomRecId;
        if (form) {
            form.dictionaries = dicts;
            form.dictionariesCodedValues = codedValues;
        }
        if (rodzajObiektu === ObjectType.KRO && (form as KrLandslideFormTypes).landslideBuildingDamages === undefined) {
            (form as KrLandslideFormTypes).landslideBuildingDamages = [];
        }
        const cardType = objectType === ObjectType.KRO ?
            (form as KrLandslideFormTypes)?.landslideAttributes?.wersja :
            (form as KrEndangeredAreaFormTypes)?.endangeredAreaAttributes?.wersjA_KARTY;
        const patternType = cardType ? cardType : PatternType.P2007;

        prepareAllFields(rodzajObiektu, patternType, form);
        var config: ConfigField = {
            Validation: createValidationKrForm(form, rodzajObiektu, patternType),
            check: false
        };
        form.config = config;

        setkrForm(form);
        setLoading(false);
        setLoadingMap(false);
    }

    useEffect(() => {
        //prevent get data after status change when open card
        if (preventReload.current) {
            preventReload.current = false;
            return;
        };

        const globalId = props.data.row.attributes.GLOBALID;
        const objectStatus = props.data.row.attributes.STAN_OBIEKTU_DOM;
        var statesChangingStatusForEdit = [ObjectState.Assigned, ObjectState.ToBeCorrected, ObjectState.Complete];
        var changeStatus = objectStatus === ObjectState.ToBeVerified || statesChangingStatusForEdit.includes(objectStatus);
    
        if (local) {
            if ((objectStatus === ObjectState.DownloadedForEdition || objectStatus === ObjectState.DownloadedForVerification ||
            objectStatus === ObjectState.Accepted || objectStatus === ObjectState.Complete)) {
                let newStatus = changeStatus ? objectStatus === ObjectState.ToBeVerified ? ObjectState.DownloadedForVerification : ObjectState.DownloadedForEdition : undefined;
                setLocalView(true);
                setLoading(true);
                const waitingRoomRecId = props.data.row?.attributes["ID"];
                getTask(globalId, newStatus).then((element) => {
                    if (element) {
                        let form = element?.elementParams.card as krFormTypes;
                        let actualStatus = element?.elementParams?.tableParams?.STAN_OBIEKTU_DOM;
                        if (changeStatus === false || actualStatus === newStatus) {
                            showChangeStatus(changeStatus, newStatus);
                            getDictionaries(configKey).then((dicts) => {
                                var dictionaries = dicts;
                                if (!dictionaries) {
                                    let Dictionaries: Dictionary = {};
                                    getAdditionalDictionaries(api.featureServices.additionalDictionariesBaseUrl, api.featureServices.additionalDictionaries[configKey], Dictionaries, true, undefined, true).then(() => {
                                        dictionaries = Dictionaries;
                                        setDicts(Dictionaries, configKey);
                                    }).catch(() => {
                                        populateFormError();
                                    });
                                }
                                getCodedValuesDictionaries().then((codedValues) => {
                                    if (!codedValues) {
                                        var authorDictId = api.featureServices.dictionariesForCodedValues.find(item => item[0] === "AUTORZY");
                                        if (authorDictId) {
                                            getDictionaryForCodedValues(api.featureServices.dictionariesForEditingBaseUrl + authorDictId[1])
                                            .then((res) => {
                                                var dictId: number = +authorDictId![1];
                                                var codedVals = getDictionariesFromLayers(res, [dictId]);
                                                setCodedValuesDictionaries(codedVals);
                                                prepareFormLocal(form, element, waitingRoomRecId, dictionaries, codedVals, objectType);                                            
                                            }).catch(() => {
                                                populateFormError();
                                            });
                                        }
                                    }
                                    else {
                                        prepareFormLocal(form, element, waitingRoomRecId, dictionaries, codedValues, objectType);
                                    }
                                })
                                .catch(() => {
                                    populateFormError();
                                })
                            })
                        } else {
                            notifyWarn({ message: "Niepowodzenie podczas zmiany statusu" });
                            setViewType(viewTypes.TaskList);
                        }
                    }
                    else {
                        notifyWarn({ message: "Nie posiadasz tej karty w swojej bazie lokalnej" });
                        setViewType(viewTypes.TaskList);
                    }
                }).catch(() => {
                    populateFormError();
                })
            } else {
                populateFormError();
            }
        } else {
            let newStatus = changeStatus ? objectStatus === ObjectState.ToBeVerified ? ObjectState.WaitingRoomEditionVerification : ObjectState.WaitingRoomEdition : undefined;
            setLoading(true);
            setLocalView(false);

            populateRegistrationCardForm(objectType, globalId, api.apiUrl + api.apiVersion, props.data.editMode, changeStatus, newStatus).then((response: any) => {
                showChangeStatus(changeStatus, newStatus);
                handlePopulateKrForm(response);
            })
            .catch(() => {
                populateFormError();
            });
        }
        return () => { }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [api.apiUrl, api.apiVersion, api.featureServices, api.featureServices.additionalDictionaries, api.featureServices.directories, api.featureServices.endangeredArea, api.featureServices.landslide, objectType, props.data.row]);

    const showChangeStatus = (isChange: boolean, newStatus?: string) => {
        if (isChange) {
            notifySuccess({ message: `Zmieniono status na '${newStatus}'` });
            preventReload.current = true;
            let newRow = { ...props.data.row, attributes: { ...props.data.row.attributes, STAN_OBIEKTU_DOM: newStatus } }
            setViewData({ row: newRow, editMode: props.data.editMode });
        }
    }

    const handlePopulateKrForm = (response: any) => {      
        var Dictionaries: Dictionary = {};
        var form = response.data as krFormTypes;
        if (form.formComments) form.formComments = prepareComments(form.formComments);
        form.waitingRoomId = props.data.row?.attributes.ID;
        getAdditionalDictionaries(api.featureServices.additionalDictionariesBaseUrl, api.featureServices.additionalDictionaries[configKey], Dictionaries, undefined, getMiejscowosciGminyWhere(form)).then(() => {
            form.dictionaries = Dictionaries;
            if (objectType === ObjectType.KRO && (form as KrLandslideFormTypes).landslideBuildingDamages === undefined) {
                (form as KrLandslideFormTypes).landslideBuildingDamages = [];
            }
            const cardType = objectType === ObjectType.KRO ?
                (form as KrLandslideFormTypes)?.landslideAttributes?.wersja :
                (form as KrEndangeredAreaFormTypes)?.endangeredAreaAttributes?.wersjA_KARTY;
            const patternType = cardType ? cardType : PatternType.P2007;

            prepareAllFields(objectType, patternType, form);
            var config: ConfigField = {
                Validation: createValidationKrForm(form, objectType, patternType),
                check: false
            };
            form.config = config;

            var authorDictId = api.featureServices.dictionariesForCodedValues.find(item => item[0] === "AUTORZY");
            if (authorDictId) {
                getDictionaryForCodedValues(api.featureServices.dictionariesForEditingBaseUrl + authorDictId[1])
                .then((res) => {
                    var dictId: number = +authorDictId![1];
                    form.dictionariesCodedValues = getDictionariesFromLayers(res, [dictId]);

                    setkrForm(form);
                    setLoading(false);
                    setLoadingMap(false);
                })
                .catch(() => {
                    populateFormError();
                });
            }                       
        }).catch(() => {
            populateFormError();
        });
    }
    
    const populateFormError = () => {
        notifyError({ message: "Próba pobrania danych dokumentu zakończona niepowodzeniem" });
        setViewType(viewTypes.TaskList);
    }
    
    const showFeatureOnMap = useCallback((row: __esri.Graphic) => {
        var objectType = row.attributes.RODZAJ_OBIEKTU;
        var idNumber = row.attributes.NUMER_IDENTYFIKACYJNY;
        if (!row.attributes.SHAPE_YES_NO || isNotDefined(idNumber) || isNotDefined(objectType)) {
            return;
        }
        const query = new Query({
            outFields: ["NUMER_IDENTYFIKACYJNY"],
            returnGeometry: true,
            where: `1=1 AND RODZAJ_OBIEKTU='${objectType}' AND NUMER_IDENTYFIKACYJNY=${idNumber}`
        })
        let _query = queryFeatureSet({ url: api.featureServices.taskList }, query);
        _query.promise.then((featureSet: any) => {
            if (featureSet.data !== null && featureSet.data.length > 0) {
                const view = mapStore.getView();
                if (view) {
                    showFeatures(view, [featureSet.data[0]]);
                }
            }
        }).catch((err: any) => { console.error('Unable get geometry'); })
    }, [api.featureServices.taskList])

    useEffect(() => {
        if (showOnMap.current) return;
        if (local === false && loadingMap === false) {
            showFeatureOnMap(props.data.row);
            showOnMap.current = true;
        }
    }, [props.data.row, showFeatureOnMap, loadingMap, local]);

    const isNotDefined = (value: any) => {
        return value === null || value === '';
    }

    const handleFirstShow = () => {
        setTimeout(() => {
            const view = mapStore.getView();
            if (view !== null) { goToAll(view); }
        }, 500)
    }

    const prepareComments = (comments: FormComment[]) => {
        var numberedComments = comments.map((item: FormComment) => {
            return { ...item, localUUID: crypto.randomUUID(), sectionHeading: getHeadingByFieldDict(item?.atrybuT_KOMENTOWANY!, isLandslide, is2007) }
        });
        return numberedComments.sort((a, b) => a.datA_KOMENTARZA! - b.datA_KOMENTARZA!);
    }

    const getMiejscowosciGminyWhere = (form: any) => {
        var gminy = (objectType === ObjectType.KRO) ? (form as KrLandslideFormTypes).landslideGminy : (form as KrEndangeredAreaFormTypes).endangeredAreaGminy;
        if (gminy && gminy?.length > 0) {
            var ids = gminy?.map(item => item.gminA_ID);
            return `GMI_ID IN(${ids.join()})`
        }
        else return undefined;
    }

    const hasGeom = () => {
        if (objectType === ObjectType.KRO) {
            return Boolean((krForm as KrLandslideFormTypes)!.landslideAttributes?.shape__Area);
        } else {
            return Boolean((krForm as KrEndangeredAreaFormTypes)!.endangeredAreaAttributes?.shape__Area);
        }
    }

    const getObjectStatuses = () => {
        const isGeom = hasGeom();
        const processMarker = props.data.row.attributes?.ZNACZNIK_PROCESU_DOM;
        return getRegistrationCardStatuses(processMarker, isGeom, false);
    }

    // Set up refs for navigation scroll
    const sectionHeadingsRef = useRef<any>(null);

    const getMapForNavScroll = () => {
        if (!sectionHeadingsRef.current) {
            // Initialize the Map on first usage.
            sectionHeadingsRef.current = new Map();
        }
        return sectionHeadingsRef.current;
    }

    const scrollToId = (itemId: any) => {
        const map = getMapForNavScroll();
        const node = map.get(itemId);
        node.scrollIntoView({
            behavior: 'smooth'
        });
    }

    // Set up refs for comments
    const formFieldRef = useRef<any>(null);

    const getMapForComment = () => {
        if (!formFieldRef.current) {
            // Initialize the Map on first usage.
            formFieldRef.current = new Map();
        }
        return formFieldRef.current;
    }

    const scrollToFieldByComment = (itemId: any) => {
        const map = getMapForComment();
        const node = map.get(itemId);
        if (node) {
            node.scrollIntoView({
                behavior: 'smooth'
            });
        }
        else {
            notifyWarn({ message: "Wybrane pole lub wiersz nie istnieje" })
        }
    }

    // Comments
    useEffect(() => {
        showNewCommentField ? setShowCommentSidebar(showNewCommentField.visible!) : setShowCommentSidebar(false);
    }, [showNewCommentField]);

    useEffect(() => {
        var commentLength = krForm.formComments?.length;
        setCommentsExist(commentLength! > 0);
        if (commentLength === 0) {
            setCommentsFilter(undefined);
            setShowCommentSidebar(false);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [krForm.formComments]);

    const handleSetClearCommentsFilterHighlight = () => {
        setCommentsFilter(undefined);
    }

    // Title bar props
    const objectState = props.data.row?.attributes?.STAN_OBIEKTU_DOM;
    var showActiveAssignVerifierBtn = canAssignVerifierInForm(functionsPermissions.assignVerifier.active, extendedUserPermissions, userRoles, objectType,
        objectState, props.data.row?.attributes?.TERYT, props.data.row?.attributes?.ZNACZNIK_PROCESU_DOM);
    var showActiveAssignEditorBtn = canAssignEditorInForm(functionsPermissions.assignEditor.active, userRoles, objectState);
    var isLandslide = objectType === ObjectType.KRO;
    var titleBarProps: TitleBarProps = {
        title: `Formularz karty rejestracyjnej ${isLandslide ? "osuwiska" : "terenu zagrożonego"}`,
        toolbar: {
            isVisible: true,
            // Is assign verifier button visible
            isVerifyBtn: showActiveAssignVerifierBtn,
            // Is assign verifier button active
            assignVerifier: showActiveAssignVerifierBtn,
            // Is assign editor button visible
            isEditorBtn: showActiveAssignEditorBtn,
            // Is assign editor button active
            assignEditor: showActiveAssignEditorBtn,
            mapBtn: true,
            executeScroll: scrollToId
        },
        isKR: true,
        objectType: objectType,
        loading: loading || loadingMap,
        setSaving: setSaving,
        saving: saving,
        objectStatesDetails: getObjectStatuses(),
        currentRow: props.data.row,
        editMode: props.data.editMode,
        local: local,
        prepareComments: prepareComments,
        setNewCommentFieldDetails: setNewCommentField,
        formRefs: [sectionHeadingsRef.current, formFieldRef.current]
    }

    var formContextProps: FormContextProps = {
        context: krForm,
        setContext: setkrForm,
        getMapForNavScroll: getMapForNavScroll,
        editMode: props.data.editMode,
        getMapForComment: getMapForComment,
        setNewCommentFieldDetails: setNewCommentField,
        setCommentsFilter: commentsExist ? setCommentsFilter : undefined,
        markedFieldForCommentFiltering: commentsExist ? commentsFilter : undefined,
    }

    const showContent = !loading && !loadingMap && !saving;
    const showComments = commentsExist || showCommentSidebar;

    return (
        <KrFormContext.Provider value={{ krForm, setkrForm, local, fillDate, setFillDate }}> <div className="formPanel">
            <TitleBar {...titleBarProps} context={krForm} setContext={setkrForm} />
            <div className="krFormViewContent" style={showComments && showContent ? { gridTemplateColumns: "60% 40%" } : { gridTemplateColumns: "100%" }}>
                <div id="scrollIndicator" className="krFormView" style={showComments && showContent ? { gridTemplateColumns: "5% 45% 45% 5%" } : { gridTemplateColumns: "20% 30% 30% 20%" }}>
                    {showContent ?
                        <div className="krFormWrapper">
                            {objectType === ObjectType.KRO && <KrFormLandslide
                                {...formContextProps}
                            />}
                            {objectType === ObjectType.KRTZ && <KrFormEndangeredArea
                                {...formContextProps}
                            />}
                        </div> :
                        <Spinner spinnerClass={ClassNameSpinner.BigGrid} />}
                </div>
                {showContent && showComments &&
                    <div className="commentSidebar">
                        <CommentsSidebar
                            newCommentFieldDetails={showNewCommentField}
                            editMode={props.data.editMode}
                            executeScroll={scrollToFieldByComment}
                            filterByField={commentsFilter}
                            setClearCommentsFilterHighlight={handleSetClearCommentsFilterHighlight}
                            isLandslide={isLandslide}
                            is2007={is2007}
                            setNewCommentFieldDetails={setNewCommentField}
                        />
                    </div>
                }
                {functionsPermissions.showObjGeomOnMap.active && !local &&
                    <SlideoutWrapper icon={MapIcon} btnPos={SlideoutBtnPosition.TopRight} onFirstShow={handleFirstShow} disable={saving} hide={loading || loadingMap}>
                        <WebMap config={api.mapComposition.waitingRoom} baseMap={api.baseMap} />
                    </SlideoutWrapper>
                }
            </div>
        </div></KrFormContext.Provider>
    )
}

export default KrFormView;